<template>
    <a :href="link.url" :class="cssClass" ref="link">
        {{link.title}}
    </a>
</template>

<script>
    // import VTitle from 'v-title';

    export default {
        name: 'SubmenuLink',
        props: ['link','idx'],
        computed:{
            cssClass:function () {
                if(this.link.isActive){
                    return 'submenu-link active';
                }
                return 'submenu-link';
            }
        },
        methods:{
            handleClick:function () {
                this.$emit('on-expand-element',this.element);
            }
        },
      mounted() {
        console.log('mounted()');
        this.$watch(()=>this.idx,(newval,oldval)=>{
          console.log('watch submenu')
          console.log(newval);
          console.log(oldval);
      }),
        console.log(this.idx);
          if(this.idx===0){
            console.log('this.$refs');
            console.log(this.$refs.link);
            this.$refs.link.focus()
          }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
<style scoped>
    .submenu-link {
        border-right-color: #313A41!important;
        border-left:6px solid #313A41;
        display:block;
        padding-left:30px;
        padding-top:4px;
        padding-bottom: 4px;
        color:#D6D7D8;
        font-size:14px;
    }
    .submenu-link.active {
        border-left:6px solid #0099BC;
        background-color: #272E34;
    }
</style>
